export default {
    NotEnoughMoney: "NotEnoughMoney",
    waitingForVerification: "waitingForVerification",
    publisherIsNotVerified: "publisherIsNotVerified"
};
